import { render, staticRenderFns } from "./SizesList.vue?vue&type=template&id=4cd6d392&scoped=true&"
import script from "./SizesList.vue?vue&type=script&lang=js&"
export * from "./SizesList.vue?vue&type=script&lang=js&"
import style0 from "./SizesList.vue?vue&type=style&index=0&id=4cd6d392&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd6d392",
  null
  
)

export default component.exports